import { h } from "preact";
import VpLogo from './vp-logo.svg';
import { vpLogoContainer, vpLogoFlexSize, vpLogoLink, vpLogo } from "./VideoPeelLogo.css";
var VideoPeelLogo = function (_a) {
    var data = _a.data;
    if (!data.showVideoPeelLogo) {
        return null;
    }
    return (h("div", { className: vpLogoContainer },
        h("div", { className: vpLogoFlexSize },
            h("a", { href: "https://videopeel.com", className: vpLogoLink, target: "_blank" },
                h("span", null,
                    "Powered by ",
                    h(VpLogo, { className: vpLogo }),
                    " VideoPeel")))));
};
export default VideoPeelLogo;
